import { zodResolver } from '@hookform/resolvers/zod'
import {
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Typography,
} from '@material-ui/core'
import { useForm } from 'react-hook-form'
import { z } from 'zod'

import Button from '@/components/button'
import { saveDiagnosisRegisterAcceptanceTerm } from '@/services/diagnosis-register-acceptance-term'

import { useStyles } from './style'

const acceptanceTermSchema = z.object({
  acceptanceTerm: z.boolean(),
})

type AcceptanceTermSchema = z.infer<typeof acceptanceTermSchema>

interface AcceptanceTermModalProps {
  open: boolean
  onClose?: () => void
  onSubmit?: () => void
}

export const AcceptanceTermModal = ({
  open,
  onClose,
  onSubmit,
}: AcceptanceTermModalProps) => {
  const classes = useStyles()

  const { handleSubmit, register } = useForm<AcceptanceTermSchema>({
    resolver: zodResolver(acceptanceTermSchema),
  })

  function onSubmitForm(data: AcceptanceTermSchema) {
    if (data.acceptanceTerm) {
      saveDiagnosisRegisterAcceptanceTerm(data.acceptanceTerm)
    }

    onSubmit?.()
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      classes={{
        paper: classes.main,
      }}
      PaperProps={{
        component: 'form',
        onSubmit: handleSubmit(onSubmitForm),
      }}
    >
      <DialogTitle disableTypography classes={{ root: classes.dialogTitle }}>
        <span className='material-symbols-outlined'>upload_file</span>
        <Typography variant={'h2'}>Cadastrar novo diagnóstico</Typography>
      </DialogTitle>
      <DialogContent
        classes={{
          root: classes.dialogContent,
        }}
      >
        <ul>
          <Typography component={'li'}>
            Declaro que os arquivos enviados estão corretos e seguem as
            especificações técnicas solicitadas.
          </Typography>

          <Typography component={'li'}>
            Autorizo a realização do diagnóstico, mesmo que o ortomosaico
            contenha até 5% de áreas sem imagens (buracos) ou com imperfeições
            em trechos de imagem (como áreas borradas ou com iluminação
            inadequada). Estou ciente de que essas imperfeições não comprometem
            significativamente o resultado final da análise.
          </Typography>
          <Typography component={'li'}>
            Permito a realização de ajustes pontuais no perímetro, caso
            necessário, visando aprimorar a precisão e a qualidade do
            diagnóstico entregue.
          </Typography>
        </ul>

        <FormControlLabel
          control={<Checkbox {...register('acceptanceTerm')} />}
          label='Lembrar minha resposta, não perguntar novamente'
        />
      </DialogContent>
      <DialogActions
        classes={{
          root: classes.dialogActions,
        }}
      >
        <Button onClick={onClose} outlined>
          Cancelar
        </Button>

        <Button type='submit'>Cadastrar diagnóstico</Button>
      </DialogActions>
    </Dialog>
  )
}
